import React, { CSSProperties } from "react";
import Checkbox from "common/Checkbox/Checkbox";
import Text from "common/Typography/Text";
import styled from "styled-components";
import { LanguageNameSpaces, OverrideFieldType } from "@shared/types";
import { useOverrideToggle } from "@shared/features/bots/BotForm/common/hooks";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { SIGNALS_BOT_OVERRIDE_TEXT } from "@shared/features/bots/BotForm/common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface OverrideToggleProps {
  overrideField: OverrideFieldType;
  style?: CSSProperties;
}

const OverrideToggle = ({ overrideField, style }: OverrideToggleProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { isChecked, onChange, helperData, shouldDisplay } =
    useOverrideToggle(overrideField);

  if (!shouldDisplay) return null;

  return (
    <Wrapper onClick={onChange} style={style}>
      <Checkbox checked={isChecked} style={{ marginRight: 12 }} $size={18} />
      <Text as="div">
        {t(SIGNALS_BOT_OVERRIDE_TEXT)}
        {helperData && <HelperTooltip {...helperData} />}
      </Text>
    </Wrapper>
  );
};

export default OverrideToggle;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 12px;
`;
